<template>
  <div
    tabindex="0"
    class="interaction-head default-interaction-head mb-0"
    :class="[
      perspectiveClass,
      enabledFeatures.includes('hotspotStyling') ? '' : 'pt-2 px-2',
    ]"
    :aria-label="`Interaction text: ${interaction.interactionText.stripHTML({ makeScreenReaderFriendly: true })}`"
  >
    <div
      class="pp-interaction-title"
      v-html="interaction.interactionText"
    ></div>
    <InteractionAttachments :attachments="interaction.interactionAttachments" />
  </div>
</template>

<script>
import _ from 'lodash';
import InteractionAttachments from '../Snippets/InteractionAttachments.vue';
import Interaction from '../../mixins/Interaction';

export default {
  name: 'InteractionHead',
  components: {
    InteractionAttachments,
  },
  mixins: [
    Interaction,
  ],
  props: {
    perspectiveKey: {
      type: String,
      required: true,
    },
    interactionBodyComponentKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    perspectiveClass() {
      return _.kebabCase(this.perspectiveKey);
    },
  },
};
</script>
